export default __webpack_public_path__ + "static/media/precios.130ab48d.png";